const corrosionLabels = {
    'Measured Corrosion Rate': {
        label: "Measured Corrosion Rate",
        color: "#FBCF09"
    },
    'Predicted Corrosion Rate': {
        label: "Predicted Corrosion Rate",
        color: "#0097BB"
    },
};

const remnantLabels = {
    'RemnentLife Alert': {
        label: "RemnentLife Alert",
        color: "#FBCF09"
    },
    'WallThickness Alert': {
        label: "WallThickness Alert",
        color: "#0097BB"
    },
};


export const getInitialData = (
  corrosionAlertsCount,
  remnantAlertsCount,
  setCorrosionDataToPlot,
  setRemnantDataToPlot
) => {
  const corrosionData = {
    labels: [],
    values: [],
    hole: 0.6,
    hoverinfo: 'label',
    marker: {
      colors: [],
      size: 1000,
      line: {
        color: "rgba(28, 28, 28, 0.38)",
        width: [1, 1, 0]
      }
    },
    type: "pie"
  };

  corrosionAlertsCount?.category?.forEach((cat, index) => {
    const count = corrosionAlertsCount.count[index];
    corrosionData.labels.push(`${corrosionLabels[cat]?.label || cat}:${count}`);
    corrosionData.values.push(count);
    corrosionData.marker.colors.push(corrosionLabels[cat]?.color || null);
  });

  setCorrosionDataToPlot(corrosionData);

  const remnantData = {
    labels: [],
    values: [],
    hole: 0.6,
    hoverinfo: 'label',
    marker: {
      colors: [],
      size: 1000,
      line: {
        color: "rgba(28, 28, 28, 0.38)",
        width: [1, 1, 0]
      }
    },
    type: "pie"
  };

  remnantAlertsCount?.eventCode?.forEach((event, index) => {
    const count = remnantAlertsCount.count[index];
    remnantData.labels.push(`${remnantLabels[event]?.label || event}:${count}`);
    remnantData.values.push(count);
    remnantData.marker.colors.push(remnantLabels[event]?.color || null);
  });

  setRemnantDataToPlot(remnantData);
};

export const updateColorsForUnmatchedLabels = (dataToPlot, targetLabel, type, setPieFilterType) => {
    if (dataToPlot) {
        const updatedColors = dataToPlot.labels.map((label, index) => {
            if (label.includes(targetLabel)) {
                if (type === "corrosion") {
                    setPieFilterType("corrosion");
                    return corrosionLabels[targetLabel].color;
                }
                if (type === "remnant") {
                    setPieFilterType("remnant");
                    return remnantLabels[targetLabel].color;
                }
            }
            return 'D9D9D9'; // Change color to grey
        });

        return {
            ...dataToPlot,
            marker: {
                ...dataToPlot.marker,
                colors: updatedColors,
            },
        };
    }
};

export const clickFilterHandler = (pieData, applyPieFilters, corrosionDataToPlot, remnantDataToPlot, setCorrosionDataToPlot, setRemnantDataToPlot, updateColorsForUnmatchedLabels) => {
    const splitToArray = (id) => id.split(":");
    const targetLabel = splitToArray(pieData.points[0].label)[0];
    applyPieFilters(targetLabel);

    const updatedCorrosionData = updateColorsForUnmatchedLabels(corrosionDataToPlot, targetLabel, "corrosion");
    setCorrosionDataToPlot(updatedCorrosionData);

    const updatedRemnantData = updateColorsForUnmatchedLabels(remnantDataToPlot, targetLabel, "remnant");
    setRemnantDataToPlot(updatedRemnantData);
};